
import Routing from './components/Routing.js';

function App() {
  return (
  <div className = "App">
    <Routing />
  </div>
  )
}

export default App;
